<template>
  <page-status class="proposal-sign" :loading="loading">
    <van-tabs
      color="#1989fa"
      :border="false"
      @click="onClick"
      :active="activeIndex"
    >
      <van-tab
        v-bind:key="index"
        v-for="(clause, index) in detail.clauseVos"
        :title="clause.clauseName"
      >
        <template #title>
          <span class="clause-name">
            <img
              style="width: 20px"
              v-if="clause.clicked"
              src="https://i3.cathay-ins.com.cn/prod/posts/962e542a313e2ae96697a98b50645427.png"
              alt=""
            />
            {{ clause.clauseName }}
          </span>
        </template>
        <div class="tooltips">
          <div class="icon">
            <img
              src="http://i3.cathay-ins.com.cn/prod/posts/1ccbd6931aa2a45c29fdbc5ff34e1357.png"
              alt="notice"
            />
          </div>
          <div class="text">请阅读至页面底部，待按钮亮起后完成确认</div>
        </div>
        <div
          class="viewer-content"
          v-if="index === activeIndex && clause.bizType === 'printProposal'"
          :data-clause-index="index"
          @scroll="handleScroll"
        >
          <pdf-viewer :url="clauseUrl" @loaded="onPdfLoaded(index)" />
        </div>
        <div
          class="viewer-content"
          v-if="index === activeIndex && clause.bizType === 'loadProposal'"
          :data-clause-index="index"
        >
          <iframe
            :src="clauseUrlfc"
            @scroll="handleScroll"
            frameborder="0"
            width="100%"
            height="100%"
            id="iframeRef"
            ref="iframeRef"
          ></iframe>
          <!-- <div
            :style="{ overflow: 'hidden', margin: '0 24px' }"
            class="none-a imgwh100"
            v-html="content"
          /> -->
        </div>
      </van-tab>
    </van-tabs>

    <!-- <div class="agreement">
      <van-checkbox v-model="checked">
        保险人已明确说明条款内容，免除保险人责任条款的含义及其法律后果
      </van-checkbox>
    </div> -->
    <div class="sign-container">
      <div class="sign-actions">
        <van-button
          :disabled="
            isUrlLoading ||
            detail.clauseVos[this.index].isScrolledToBottom ||
            detail.clauseVos[this.index].isClick
          "
          :loading="isUrlLoading"
          loading-text="正在加载中..."
          class="button"
          type="info"
          @click="readed()"
        >
          {{
            detail.clauseVos[this.index].isClick
              ? `请您仔细阅读以上信息${time}秒`
              : `我已阅读`
          }}
        </van-button>
      </div>
    </div>

    <page-footer />
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import PageStatus from '@/components/PageStatus';
import PageFooter from '@/components/PageFooter';
import PdfViewer from '@/components/PdfViewer';
import * as services from '@/services';
import * as cache from '@/utils/cache';
import pdfjsLib from 'pdfjs-dist/build/pdf.js';

let timer;

export default {
  name: 'ProposalTerm',
  components: {
    PageStatus,
    PageFooter,
    PdfViewer,
  },

  data() {
    return {
      detail: {
        appliName: '',
        insuredName: '',
        biProposalNo: '',
        ciProposalNo: '',
        licenseNo: '',
        frameNo: '',
        totalPremium: '',
        payStatus: '',
        clauseVos: [],
      },
      loading: true,
      checked: false,
      clauseUrl: '',
      clauseUrlfc: '',
      pdfLoaded: false,
      // outputImage: [],
      checkSignFlag: true, //是否需要验证签名
      faceIdFlag: false, //是否需要人脸识别
      onlyShowJcFrame: false,
      time: 5,
      isClick: true,
      index: 0,
      activeIndex: 0,
      isReadOnce: false,
      content: '',
      clauseUrlCache: {},
      clauseScrollPositions: {},
      clauseTimes: {},
      clauseRequestId: 0,
      initialClauseTimer: null,
    };
  },

  computed: {
    isUrlLoading() {
      const clause = this.detail.clauseVos[this.index] || {};
      if (clause.bizType === 'printProposal')
        return !this.clauseUrl || !this.pdfLoaded;
      if (clause.bizType === 'loadProposal') return !this.clauseUrlfc;
      return false;
    },
  },
  watch: {},

  created() {
    // const { recorder } = getUseRecord();
    // this.recorder = recorder;
    // recorder.start();
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  destroyed() {
    this.clauseRequestId++;
    if (this.initialClauseTimer) clearTimeout(this.initialClauseTimer);
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    // this.recorder.unload();
  },
  methods: {
    fetchData() {
      const { businessNo, mobile } = this.$route.query;
      const proposalAuth = cache.removeItem('ProposalAuth');
      if (this.checkSameProposal(proposalAuth, businessNo, mobile)) {
        // this.isNoCar = false;
        this.getProposalSuccess(proposalAuth);
        return;
      }

      services.getMotorProposal(businessNo, mobile).then(res => {
        // this.isNoCar = true;
        this.getProposalSuccess(res);
      });
      // this.trace();
    },
    trace() {
      const { businessNo } = this.$route.query;
      const recordInfoStr = window.sessionStorage.getItem('recordInfo');
      const { recordId } = JSON.parse(recordInfoStr);
      services.traceable(businessNo, recordId);
    },

    handleScroll(event) {
      const element = event.target;
      this.clauseScrollPositions[this.index] = element.scrollTop;
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        const clause = this.detail.clauseVos[this.index];
        this.$set(this.detail.clauseVos, this.index, {
          ...clause,
          isScrolledToBottom: false,
        });
      }
    },

    onClick(event) {
      if (event === this.index) return;
      this.saveClauseState(this.index);
      this.index = event;
      this.activeIndex = event;
      this.onViewClause(event);
    },
    getProposalSuccess(res) {
      const { businessNo, mobile } = this.$route.query;
      if (res.data.policyInfo.payStatus === '1') {
        const query = { businessNo, mobile };
        this.$router.replace({ path: '/insure-result', query });
      } else {
        this.checkSignFlag = res.data.checkSignFlag;
        this.faceIdFlag = res.data.faceIdFlag;
        this.realAuthSmsFlag = res.data.realAuthSmsFlag;
        this.detail = { ...this.detail, ...res.data.policyInfo };
        this.detail.clauseVos =
          res.data.policyInfo.clauseVos?.map(item => {
            // 单页不需要滚动
            // 非车条款不需要等待
            if (item.isTimed === '1') {
              return {
                ...item,
                isClick: true,
                isScrolledToBottom: false,
                clicked: false,
              };
            } else if (item.isTimed === '0') {
              // isClick false不需要等待五秒 isScrolledToBottom 需要滚动到底部
              return {
                ...item,
                isClick: false,
                isScrolledToBottom: false,
                clicked: false,
              };
            } else {
              return {
                ...item,
                isClick: false,
                isScrolledToBottom: false,
                clicked: false,
              };
            }
          }) || [];
        this.onlyShowJcFrame = res.data.policyInfo.onlyShowJcFrame;
        this.jcTotalPremium = res.data.policyInfo.jcTotalPremium;
        this.loading = false;
        this.initialClauseTimer = setTimeout(() => {
          this.initialClauseTimer = null;
          this.onViewClause(0);
        }, 1000);
        // if (this.isNoCar) {
        //   services
        //     .queryNoCarReadList(businessNo, mobile)
        //     .then(result => this.getNoCarReadListSuccess(result))
        //     .finally(() => {
        //       setTimeout(() => {
        //         this.onViewClause(0);
        //       }, 1000);
        //     });
        // }
      }
    },
    checkSameProposal(proposalAuth, businessNo, mobile) {
      return (
        proposalAuth &&
        proposalAuth.businessNo === businessNo &&
        proposalAuth.mobile === mobile
      );
    },

    readed() {
      const clause = this.detail.clauseVos[this.index];
      this.$set(this.detail.clauseVos, this.index, {
        ...clause,
        clicked: true,
      });
      this.saveClauseState(this.index);
      this.index = this.index + 1;
      this.activeIndex = this.activeIndex + 1;

      if (this.index === this.detail.clauseVos.length || this.isReadOnce) {
        this.isReadOnce = true;
        const unreadItemIndex = this.detail.clauseVos.findIndex(
          item => !item.clicked,
        );
        this.activeIndex = unreadItemIndex;
        this.index = unreadItemIndex;
        if (unreadItemIndex !== -1) {
          this.onViewClause(unreadItemIndex);
        } else {
          this.checked = true;
          this.toNextPage();
        }
      } else {
        this.onViewClause(this.index);
      }
    },
    async onViewClause(index) {
      if (index !== this.index) return;
      const requestId = ++this.clauseRequestId;
      this.clauseUrl = null;
      this.clauseUrlfc = null;
      this.pdfLoaded = false;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      const { mobile } = this.$route.query;
      const clause = this.detail.clauseVos[index] || {};
      this.time = this.clauseTimes[index] || 5;
      if (clause.bizType === 'printProposal') {
        let clauseUrl = this.clauseUrlCache[index];
        if (!clauseUrl) {
          clauseUrl = await services.getMotorProposalLink(clause, mobile);
          if (requestId !== this.clauseRequestId || index !== this.index) {
            return;
          }
          this.$set(this.clauseUrlCache, index, clauseUrl);
        }
        if (requestId !== this.clauseRequestId || index !== this.index) {
          return;
        }
        this.clauseUrl = clauseUrl;
        // 倒计时在 onPdfLoaded 中启动，等 PDF 内容加载完
      } else {
        if (requestId !== this.clauseRequestId || index !== this.index) {
          return;
        }
        this.clauseUrlfc = clause.clauseModelUrl;
        this.restoreScrollPosition(index);
        if (clause?.isClick) {
          this.countdown();
        }
      }
    },
    onPdfLoaded(index) {
      if (index !== this.index) return;
      this.pdfLoaded = true;
      this.restoreScrollPosition(index);
      // PDF 内容加载完，开始倒计时
      const clause = this.detail.clauseVos[this.index] || {};
      if (clause?.isClick) {
        this.countdown();
      }
    },
    saveClauseState(index) {
      if (index < 0) return;
      this.clauseTimes[index] = this.time;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    },
    restoreScrollPosition(index) {
      this.$nextTick(() => {
        const element = this.$el.querySelector(
          `.viewer-content[data-clause-index="${index}"]`,
        );
        if (element) {
          element.scrollTop = this.clauseScrollPositions[index] || 0;
        }
      });
    },
    countdown() {
      if (timer) {
        clearInterval(timer);
      }
      timer = setInterval(() => {
        if (this.time !== 1) {
          this.time -= 1;
          this.clauseTimes[this.index] = this.time;
        } else {
          const clause = this.detail.clauseVos[this.index];
          this.$set(this.detail.clauseVos, this.index, {
            ...clause,
            isClick: false,
          });
          clearInterval(timer);
          timer = null;
          this.clauseTimes[this.index] = 5;
          this.time = 5;
        }
      }, 1000);
    },

    toNextPage(checkMessageFlag = false) {
      if (!this.checked) {
        Toast({ message: '请确认勾选已阅读并接受以上条款信息' });
        return;
      }
      const { comCode } = this.detail.clauseVos[0] || {};

      const { query } = this.$route;
      const params = {
        ...query,
        realAuthSmsFlag: this.realAuthSmsFlag,
        comCode,
      };
      if (this.faceIdFlag) {
        this.$router.push({ path: '/certify', query: params });
      } else if (this.checkSignFlag) {
        this.$router.push({ path: '/signature', query: params });
      } else if (checkMessageFlag) {
        this.$router.push({ path: '/proposal-auth', query: params });
      } else if (realAuthSmsFlag) {
        this.$router.push({ path: '/eproposal/sms', query: params });
      } else {
        this.$router.push({ path: '/insure-payment', query: params });
      }
    },
  },
};
</script>

<style lang="less">
.proposal-sign {
  width: 100%;
  height: 100%;
  padding-top: 12px;
  box-sizing: border-box;
  overflow: hidden;

  .address-detail {
    flex: 2;
  }
  .clause.active {
    color: #108ee9;
  }

  .agreement {
    padding: 12px;
    font-size: 14px;
  }

  .sign-container {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    padding: 8px 12px;
    background: #fff;
    z-index: 10;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }

  .sign-content {
    background-color: #fafafa;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
  }

  .sign-actions {
    margin-top: 12px;
    text-align: center;
    display: flex;

    .button {
      flex: 1;
      border-radius: 4px;

      & + .button {
        margin-left: 12px;
      }
    }
  }

  .dialog-content {
    padding: 12px 24px;
    font-size: 14px;
    color: #030303;
    text-align: center;
  }

  .viewer-content {
    height: calc(100vh - 180px);
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    background-color: #f9f9f9;
  }
  .viewer-footer {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 100%;
    }
  }
  .clause-image {
    margin: 24px;
  }
  .clause-image-item {
    display: flex;
  }
  .van-tab__text {
    min-width: 100px;
    max-width: 250px;
    text-align: center;
  }
  .van-tabs__content {
    height: 90%;
  }
  .van-tabs__nav {
    overflow-x: scroll;
  }
  .tooltips {
    background-color: #fff9ed;
    width: 718px;
    padding: 0 16px;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon {
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .text {
      font-size: 14px;
      color: #ff6010;
      margin-left: 10px;
    }
    .clause-name {
      img {
        width: 20px;
      }
    }
  }
}
</style>
